import Tone from 'tone';
import Synth from '../synth';

//create an autopanner and start it's LFO
var autoPanner = new Tone.AutoPanner(.1).start();
autoPanner.depth.value = .4;

var EQ = new Tone.EQ3(-5, 0, 0);

const synth = new Synth('basic', Tone.MonoSynth, {
  envelope: {
    attack: .01,
    velocity: .8,
    release: 1.3
  },
  oscillator:{
    type: "sine",
    frequency: .2,
  },
  filter:{
    Q: 2,
    type: "bandpass",
    frequency: 4000,
    octaves: 10,
    rolloff: -12
  },
  filterEnvelope: {
    attack: 1.5,
    sustain: .6,
    // decay: 1,
    octaves: 4,
    // baseFrequency: 400
  }
});

const vibrato = new Tone.Vibrato({
  frequency: '1m',
  depth: .4
});

synth.chain(EQ, autoPanner, vibrato, Tone.Master);

export default synth;

window.synth = synth;



// WEBPACK FOOTER //
// ./src/synths/steeldrum.js